import { render, staticRenderFns } from "./btn-hamburger-primary.vue?vue&type=template&id=4cdf1353&scoped=true"
import script from "./btn-hamburger-primary.vue?vue&type=script&lang=js"
export * from "./btn-hamburger-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdf1353",
  null
  
)

export default component.exports